import { Controller } from "@hotwired/stimulus"

// Menu mobile da navbar. Fecha em Esc, ao clicar em link do painel e antes
// do cache do Turbo (o snapshot nunca deve guardar o menu aberto).
export default class extends Controller {
  static targets = ["menu", "toggle"]

  connect() {
    this.close = this.close.bind(this)
    document.addEventListener("turbo:before-cache", this.close)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.close)
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.toggleTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.toggleTarget.setAttribute("aria-expanded", "false")
  }
}
